var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgKeepOff = function SvgKeepOff(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2632",
    d: "m9.533 7.65-4.7-4.7a.6.6 0 0 1-.125-.183.5.5 0 0 1-.041-.2q0-.217.15-.392a.5.5 0 0 1 .4-.175h5.45q.283 0 .475.192a.65.65 0 0 1 .191.475.38.38 0 0 1-.241.375q-.242.109-.425.291v3.834q0 .45-.409.625-.408.175-.725-.142m-2.2 7.017v-4h-2.4a.83.83 0 0 1-.666-.292.99.99 0 0 1-.25-.658q0-.184.075-.367T4.333 9l1-1v-.767L1.4 3.267a.65.65 0 0 1-.192-.459.62.62 0 0 1 .192-.475.63.63 0 0 1 .467-.183q.283 0 .466.183L13.65 13.65a.62.62 0 0 1 .192.475.68.68 0 0 1-.675.667.61.61 0 0 1-.467-.192l-3.933-3.933h-.1v4a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.191.65.65 0 0 1-.475-.191.65.65 0 0 1-.192-.475"
  })));
};
export default SvgKeepOff;